import { createApp } from 'vue';
import ReferencesList from './ReferencesList.vue';

import './ReferenceItemContainer.scss'


const referencesListContainers = document.querySelectorAll(
    "[data-feature='referencesList']"
);

referencesListContainers.forEach((referencesListContainer) => {
    const app = createApp({
        name: 'ReferencesListApp',
    });

    app.component('references-list', ReferencesList);
    app.mount(referencesListContainer);
});
